import label from "@/lang/StaticLabels.js";

// PORDR Router  - سفارشات -----------------------------------------------
let routeItems = {
  path: "PORDR",
  name: "PORDR",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PORDRDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PORDRDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.pordr,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pordr/Dashboard.vue"),
    },
    // Base Information  -----------------------------------------------
    {
      path: "blackList",
      name: "PORDRBlackList",
      meta: {
        label: label.page.blackList,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pordr/base/blackList"),
    },
    {
      path: "saleManagerDiscountLimit",
      name: "PORDRSaleManagerDiscountLimit",
      meta: {
        label: label.page.saleManagerDiscountLimit,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pordr/base/saleManagerDiscountLimit"),
    },
    {
      path: "saleManagerCredit",
      name: "PORDRSaleManagerCredit",
      meta: {
        label: label.page.saleManagerCredit,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pordr/base/saleManagerCredit"),
    },
    {
      path: "settlementType",
      name: "PORDRSettlementType",
      meta: {
        label: label.page.settlementType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pordr/base/settlementType"),
    },
    {
      path: "setting",
      name: "PORDRSetting",
      meta: {
        label: label.page.orderSetting,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pordr/base/setting"),
    },
    // Operation  -----------------------------------------------
    {
      path: "order",
      name: "PORDROrder",
      meta: {
        label: label.page.saleOrder,
        requiresAuth: true,
      },
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "list",
          name: "PORDROrderList",
          component: () =>
            import("@/views/modules/pordr/operation/order/index.vue"),
          meta: {
            label: label.page.saleOrder,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PORDROrderAdd",
          component: () =>
            import("@/views/modules/pordr/operation/order/add.vue"),
          meta: {
            label: label.page.addSaleOrder,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PORDROrderEdit",
          component: () =>
            import("@/views/modules/pordr/operation/order/add.vue"),
          meta: {
            label: label.page.editSaleOrder,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "orderCartable",
      name: "PORDROrderCartable",
      meta: {
        label: label.page.saleOrderCartable,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pordr/operation/orderCartable/index.vue"),
    },
    {
      path: "orderManagementCartable",
      name: "PORDROrderManagementCartable",
      meta: {
        label: label.page.saleOrderManagementCartable,
        requiresAuth: true,
      },
      component: () =>
        import(
          "@/views/modules/pordr/operation/orderManagementCartable/index.vue"
        ),
    },
    {
      path: "orderPermitCartable",
      name: "PORDROrderPermitCartable",
      meta: {
        label: label.page.orderPermitCartable,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pordr/operation/orderPermit/Cartable.vue"),
    },
    {
      path: "orderPermit",
      name: "PORDROrderPermit",
      meta: {
        label: label.page.orderPermitList,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pordr/operation/orderPermit/index.vue"),
    },
    {
      path: "orderDraftCartable",
      name: "PORDROrderDraftCartable",
      meta: {
        label: label.page.orderDraftCartable,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pordr/operation/orderDraft/Cartable.vue"),
    },
    {
      path: "orderDraft",
      name: "PORDROrderDraft",
      meta: {
        label: label.page.orderDraftList,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pordr/operation/orderDraft/index.vue"),
    },
  ],
};

export default routeItems;
